export const UPDATE_SEARCH_PARAMS = "UPDATE_SEARCH_PARAMS";
export const UPDATE_PROPERTIES = "UPDATE_PROPERTIES";
export const UPDATE_PROPERTY = "UPDATE_PROPERTY";
export const UPDATE_UNITS = "UPDATE_UNITS";
export const UPDATE_CAN_CHANGE = "UPDATE_CAN_CHANGE";
export const UPDATE_PROPERTY_TYPE = "UPDATE_PROPERTY_TYPE";
export const RESET = "RESET";
